const articlesModule = {
  firestorePath: "articless",
  firestoreRefType: "collection", // or 'doc'
  moduleName: "articles",
  statePropName: "articles",
  namespaced: true, // automatically added
  // this object is your store module (will be added as '/myModule')
  // you can also add state/getters/mutations/actions
  state: {},
  getters: {},
  mutations: {},
  actions: {}
};
export default articlesModule;
